import React, {Component} from 'react';
import {Card, Button, Header, Form} from 'semantic-ui-react';
import update from 'react-addons-update';
import Alert from "../../components/extras/Alert";

import UserData from "../../data/UserData";

class AboutYou extends Component {
    constructor(props) {
        super(props);

        this.state = {
            display: 'none',
            user: {
                first_name: '',
                last_name: '',
                phone: '',
                address: ''
            },
            first_name_error: false,
            last_name_error: false,
            phone_error: false,
            address_error: false,
            loading: false
        };

        this.next = this.next.bind(this);
        this.open = this.open.bind(this);
        this.finish = this.finish.bind(this);
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
    }

    next() {
        this.setState({display: 'none'});
        this.props.next();
    }

    finish() {
        if (this.state.user.first_name === '') {
            this.setState({first_name_error: true})
        } else if (this.state.user.last_name === '') {
            this.setState({last_name_error: true})
        } else if (this.state.user.phone === '') {
            this.setState({phone_error: true})
        } else if (this.state.user.address === '') {
            this.setState({address_error: true})
        } else {
            this.setState({loading: true});
            UserData.setup(this.state.user, (res) => {
                if (res.update) {
                    this.setState({display: 'none'});
                    this.props.finish();
                } else {
                    this.refs.alert.open({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                }
                this.setState({loading: false});
            });
        }
    }

    open() {
        this.setState({display: 'block'});
    }

    back() {
        this.setState({display: 'none'});
        this.props.back();
    }

    handleFirstNameChange(event) {
        let data = update(this.state, {
            user: {
                first_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({first_name_error: true});
        } else {
            this.setState({first_name_error: false});
        }
    };

    handleLastNameChange(event) {
        let data = update(this.state, {
            user: {
                last_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({last_name_error: true});
        } else {
            this.setState({last_name_error: false});
        }
    };

    handlePhoneChange(event) {
        let data = update(this.state, {
            user: {
                phone: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({phone_error: true});
        } else {
            this.setState({phone_error: false});
        }
    };

    handleAddressChange(event) {
        let data = update(this.state, {
            user: {
                address: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({address_error: true});
        } else {
            this.setState({address_error: false});
        }
    };


    render() {
        return (
            <Card fluid style={{display: this.state.display}}>
                <Header as='h1' textAlign='center' style={{'marginTop': 10, 'paddingTop': 10}}>Acerca de tí</Header>
                <Card.Content>
                    <Form>
                        <Form.Group widths='equal'>
                            <Form.Input label='Nombre' placeholder='Nombre' value={this.state.user.first_name}
                                        onChange={this.handleFirstNameChange} error={this.state.first_name_error}/>
                            <Form.Input label='Apellido' placeholder='Apellido' value={this.state.user.last_name}
                                        onChange={this.handleLastNameChange} error={this.state.last_name_error}/>
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Input label='Teléfono' placeholder='Teléfono' value={this.state.user.phone}
                                        onChange={this.handlePhoneChange} error={this.state.phone_error}/>
                            <Form.Input label='Dirección' placeholder='Dirección' value={this.state.user.address}
                                        onChange={this.handleAddressChange} error={this.state.address_error}/>
                        </Form.Group>
                    </Form>
                </Card.Content>
                <Card.Content extra>
                    <Button basic floated='left' onClick={() => this.back()}>
                        Volver
                    </Button>
                    <Button primary floated='right' onClick={() => this.finish()} loading={this.state.loading} disabled={this.state.loading}>
                        Finalizar
                    </Button>
                </Card.Content>
                <Alert ref='alert'/>
            </Card>
        );
    }
}

export default AboutYou;



// WEBPACK FOOTER //
// ./src/components/setup/AboutYou.js